import { render, staticRenderFns } from "./PrizePicker.vue?vue&type=template&id=4b35d368&scoped=true&"
import script from "./PrizePicker.vue?vue&type=script&lang=js&"
export * from "./PrizePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35d368",
  null
  
)

export default component.exports